import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {ConcreteUsageConfiguration} from './types'

export const buildUsageConfiguration = ({
  options
}: BuildConfigurationInput): ConcreteUsageConfiguration => {
  return {
    concreteUsage: {
      isEnabled: options.constraints.usage?.isEnabled ?? false,
      concreteUsageValues: ['rawPour', 'floor', 'wall', 'fillingHoles', 'polishedFloor'],
      validation: {
        minLength: 0,
        maxLength: 72,
        required: true
      }
    }
  }
}
